// extracted by mini-css-extract-plugin
export default {"row":"EventOfferPerEvent_row__zxOt5","wrapper":"EventOfferPerEvent_wrapper__+i5gC","item":"EventOfferPerEvent_item__52YvH"};